import { ReactNode } from "react";

import { SplashLogo, SplashScreen } from "@dfp/react-api-core";
import { AppLogo } from "@dfp/react-components";
import { UsercentricsConsentGate } from "@dfp/react-usercentrics";

import { USERCENTRICS_SETTINGS_ID } from "../config.ts";

type ConsentGateProps = {
  children: ReactNode;
};

/**
 * App-local Usercentrics consent gate with the bw branding/config baked in. Wrap it
 * around any sub-app that should collect cookie consent before redirecting to ADB2C
 * (Dashboard, Join, Signup). Deliberately NOT applied to /ops or the mobile webview
 * routes. No-op when VITE_USERCENTRICS_SETTINGS_ID is unset.
 */
export function ConsentGate({ children }: ConsentGateProps) {
  return (
    <UsercentricsConsentGate
      settingsId={USERCENTRICS_SETTINGS_ID}
      logo={<AppLogo svg="direct_fidoo.svg" height={48} />}
      backdrop={<SplashLogo animated={false} />}
      loadingFallback={<SplashScreen />}
    >
      {children}
    </UsercentricsConsentGate>
  );
}
